import { render, staticRenderFns } from "./BangKhachHang.vue?vue&type=template&id=4d815e80&"
import script from "./BangKhachHang.vue?vue&type=script&lang=js&"
export * from "./BangKhachHang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports